/**
 * Table Clinical
 * Clinical non clinical display used by some tables
 */
import { Chip, Typography } from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';

export const TableClinical: React.FC<{ value: string }> = ({ value = '' }) => {
  return (
    <Chip
      icon={
        <Icon
          color="purple.main"
          name="circle"
          type={value === 'Clinical' ? 'fas' : 'far'}
        />
      }
      label={
        <Typography
          color="text.secondary"
          variant="body2"
          sx={{ textTransform: 'capitalize' }}
        >
          {value}
        </Typography>
      }
      sx={{
        borderColor: (theme) => theme.palette.purple.main,
      }}
      variant="outlined"
    />
  );
};
